export const remToPx = (rem: string) =>
  Number(rem.replace('rem', '')) * 14 + 'px';
